/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-empty-interface */ export function actionCreator(type) {
    return (payload)=>({
            type,
            payload
        });
}
export function isType(action, type) {
    return action.type === type;
}
export const RehydrateClientStateAction = 'RehydrateClientStateAction';
export const createRehydrateClientStateAction = actionCreator(RehydrateClientStateAction);
export const SearchboxInputChangedAction = 'SearchboxInputChangedAction';
export const createSearchboxInputChangedAction = actionCreator(SearchboxInputChangedAction);
export const SuggestedChangeAction = 'SuggestedChangeAction';
export const createSuggestedChangeAction = actionCreator(SuggestedChangeAction);
export const SearchSortingOptionChangedAction = 'SearchSortingOptionChangedAction';
export const createSearchSortingOptionChangedAction = actionCreator(SearchSortingOptionChangedAction);
export const LiveSearchboxFilterAction = 'BasicSearchboxChangedAction';
export const createLiveSearchboxFilterAction = actionCreator(LiveSearchboxFilterAction);
export const ModalAction = 'ModalAction';
export const createModalAction = actionCreator(ModalAction);
export const VideoModalAction = 'VideoModalAction';
export const createVideoModalAction = actionCreator(VideoModalAction);
export const MediaModalAction = 'MediaModalAction';
export const createMediaModalAction = actionCreator(MediaModalAction);
export const DriveModalAction = 'DriveModalAction';
export const createDriveModalAction = actionCreator(DriveModalAction);
export const IFieldHubModalAction = 'IFieldHubModalAction';
export const createIFieldHubModalAction = actionCreator(IFieldHubModalAction);
export const IDisclaimerModalAction = 'IDisclaimerModalAction';
export const createIDisclaimerModalAction = actionCreator(IDisclaimerModalAction);
export const InstructionsModalAction = 'InstructionsModalAction';
export const createInstructionsModalAction = actionCreator(InstructionsModalAction);
export const RatingAction = 'RatingAction';
export const createRatingAction = actionCreator(RatingAction);
export const BreadcrumbAction = 'BreadcrumbAction';
export const createBreadcrumbAction = actionCreator(BreadcrumbAction);
export const SetCurrentViewAction = 'SetCurrentView';
export const createSetCurrentViewAction = actionCreator(SetCurrentViewAction);
// determine current rendered gallery page is curated view or filtered view
// it should be undefined when currentView is not a gallery page
export const UpdateCurrentGalleryViewIsCuratedAction = 'UpdateCurrentGalleryViewIsCuratedAction';
export const createUpdateCurrentGalleryViewIsCurated = actionCreator(UpdateCurrentGalleryViewIsCuratedAction);
export const SetLandingViewAction = 'SetLandingView';
export const createSetLandingViewAction = actionCreator(SetLandingViewAction);
export const EnableNewNpsAction = 'EnableNewNps';
export const createEnableNewNpsAction = actionCreator(EnableNewNpsAction);
export const SetInitializedPCAInstanceAction = 'SetInitializedPCA';
export const createSetInitializedPCAInstanceAction = actionCreator(SetInitializedPCAInstanceAction);
export const SetIsNpsLogicVerifiedAction = 'SetIsNpsLogicVerified';
export const createSetIsNpsLogicVerifiedAction = actionCreator(SetIsNpsLogicVerifiedAction);
export const ShowingResultsForReceviedAction = 'ShowingResultsForReceviedAction';
export const createShowingResultsForReceivedAction = actionCreator(ShowingResultsForReceviedAction);
export const FilteredSearchResultsReceivedAction = 'FilteredSearchResultsReceivedAction';
export const createFilteredSearchResultsReceivedAction = actionCreator(FilteredSearchResultsReceivedAction);
export const PartnerSearchResultsReceivedAction = 'PartnerSearchResultsReceivedAction';
export const createPartnerSearchResultsReceivedAction = actionCreator(PartnerSearchResultsReceivedAction);
export const EntityDataReceivedAction = 'EntityDataReceivedAction';
export const createEntityDataReceivedAction = actionCreator(EntityDataReceivedAction);
export const UserProfileLoadingAction = 'UserProfileLoadingAction';
export const createUserProfileLoadingAction = actionCreator(UserProfileLoadingAction);
export const UserProfileAction = 'UserProfileAction';
export const createUserProfileAction = actionCreator(UserProfileAction);
export const UserTenantsDetailsAction = 'UserTenantsDetailsAction';
export const createUserTenantsDetailsAction = actionCreator(UserTenantsDetailsAction);
export const UserTenantsDetailsLoadingAction = 'UserTenantsDetailsLoadingAction';
export const createUserTenantsDetailsLoadingAction = actionCreator(UserTenantsDetailsLoadingAction);
export const UpdateUserProfileAction = 'UpdateUserProfileAction';
export const createUpdateUserProfileAction = actionCreator(UpdateUserProfileAction);
export const SetAccountAction = 'SetAccountAction';
export const createSetAccountAction = actionCreator(SetAccountAction);
export const SetAccountIsLoadingAction = 'SetAccountIsLoadingAction';
export const createSetAccountIsLoadingAction = actionCreator(SetAccountIsLoadingAction);
export const SetIsMaccTenantAction = 'SetIsMaccTenantAction';
export const createSetIsMaccTenantAction = actionCreator(SetIsMaccTenantAction);
export const UpdateUserProfileLicenseAction = 'UpdateUserProfileLicenseAction';
export const createUpdateUserProfileLicenseAction = actionCreator(UpdateUserProfileLicenseAction);
/** Updates IUserDataState only clears the phone number to string empty */ export const ClearUserPropertiesAction = 'ClearUserPropertiesAction';
export const createClearUserPropertiesAction = actionCreator(ClearUserPropertiesAction);
// Actions for SI Partners - End
export const PowerBIDataReceivedAction = 'PowerBIDataReceivedAction';
export const createPowerBIDataReceivedAction = actionCreator(PowerBIDataReceivedAction);
export const PartnerAppDataReceivedAction = 'PartnerAppDataReceivedAction';
export const createPartnerAppDataReceivedAction = actionCreator(PartnerAppDataReceivedAction);
export const SetEntityIdLoadingAction = 'SetEntityIdLoadingAction';
export const createSetEntityIdLoadingAction = actionCreator(SetEntityIdLoadingAction);
export const SetEntityIdFailedAction = 'SetEntityIdFailedAction';
export const createSetEntityIdFailedAction = actionCreator(SetEntityIdFailedAction);
export const EntityDetailsReceivedAction = 'EntityDetailsReceivedAction';
export const createEntityDetailsReceivedAction = actionCreator(EntityDetailsReceivedAction);
export const EntityFullDataReceivedAction = 'EntityFullDataReceivedAction';
export const createEntityFullDataReceivedAction = actionCreator(EntityFullDataReceivedAction);
export const EntityReviewCommentsReceivedAction = 'EntityReviewCommentsReceivedAction';
export const createEntityReviewCommentsReceivedAction = actionCreator(EntityReviewCommentsReceivedAction);
export const EntityReviewCommentsLoadingAction = 'EntityReviewCommentsLoadingAction';
export const createEntityReviewCommentsLoadingAction = actionCreator(EntityReviewCommentsLoadingAction);
export const EntityReviewCommentsCleanupAction = 'EntityReviewCommentsCleanupAction';
export const createEntityReviewCommentsCleanupAction = actionCreator(EntityReviewCommentsCleanupAction);
export const EntityReviewCommentCreateResult = 'EntityReviewCommentCreateResult';
export const createEntityReviewCommentCreateResult = actionCreator(EntityReviewCommentCreateResult);
export const EntityReviewCommentDeleteResult = 'EntityReviewCommentDeleteResult';
export const createEntityReviewCommentDeleteResult = actionCreator(EntityReviewCommentDeleteResult);
export const EntityReviewCommentUpdateResult = 'EntityReviewCommentUpdateResult';
export const createEntityReviewCommentUpdateResult = actionCreator(EntityReviewCommentUpdateResult);
export const EntityReviewCommentModalAction = 'EntityReviewCommentModalAction';
export const createEntityReviewCommentModalAction = actionCreator(EntityReviewCommentModalAction);
export const EntityReviewCommentsUpdateTotalCommentCountAction = 'EntityReviewCommentsUpdateTotalCommentCountAction';
export const createEntityReviewCommentsUpdateTotalCommentCountAction = actionCreator(EntityReviewCommentsUpdateTotalCommentCountAction);
export const EntityReviewCommentsUnloadPagesAction = 'EntityReviewCommentsUnloadPagesAction';
export const createEntityReviewCommentsUnloadPagesAction = actionCreator(EntityReviewCommentsUnloadPagesAction);
export const EntityReviewCommentsInitializeStateAction = 'EntityReviewCommentsInitializeStateAction';
export const createEntityReviewCommentsInitializeStateAction = actionCreator(EntityReviewCommentsInitializeStateAction);
export const EntityMarkedAsHelpfulReviewUpdateListAction = 'EntityMarkedAsHelpfulReviewUpdateListAction';
export const createEntityMarkedAsHelpfulReviewUpdateListAction = actionCreator(EntityMarkedAsHelpfulReviewUpdateListAction);
export const EntityUserCommentedReviewIdsUpdateListAction = 'EntityUserCommentedReviewIdsUpdateListAction';
export const createEntityUserCommentedReviewIdsUpdateListAction = actionCreator(EntityUserCommentedReviewIdsUpdateListAction);
export const EntityLinkedInProductGroupUpdateAction = 'EntityLinkedInProductGroupUpdateAction';
export const createEntityLinkedInProductGroupUpdateAction = actionCreator(EntityLinkedInProductGroupUpdateAction);
export const EntityReviewSetIsHelpfulLoadingAction = 'EntityReviewSetIsHelpfulLoadingAction';
export const createEntityReviewSetIsHelpfulLoadingAction = actionCreator(EntityReviewSetIsHelpfulLoadingAction);
export const EntityReviewSetIsHelpfulAction = 'EntityReviewSetIsHelpfulAction';
export const createEntityReviewSetIsHelpfulAction = actionCreator(EntityReviewSetIsHelpfulAction);
export const EntityReviewMarkAsHelpfulModalAction = 'EntityReviewMarkAsHelpfulModalAction';
export const createEntityReviewMarkAsHelpfulModalAction = actionCreator(EntityReviewMarkAsHelpfulModalAction);
export const EntityReviewSetMarkAsHelpfulCount = 'EntityReviewSetMarkAsHelpfulCount';
export const createEntityReviewSetMarkAsHelpfulCount = actionCreator(EntityReviewSetMarkAsHelpfulCount);
export const RelatedAppsItemsLoadingAction = 'RelatedAppsItemsLoadingAction';
export const createRelatedAppsItemsLoadingAction = actionCreator(RelatedAppsItemsLoadingAction);
export const GetAppReviewsAction = 'GetAppReviewsAction';
export const createGetAppReviewsAction = actionCreator(GetAppReviewsAction);
export const SetStorefrontNameAction = 'SetStorefrontNameAction';
export const createSetStorefrontNameAction = actionCreator(SetStorefrontNameAction);
export const RelatedAppsItemsReceivedAction = 'RelatedAppsItemsReceivedAction';
export const createRelatedAppsItemsReceivedAction = actionCreator(RelatedAppsItemsReceivedAction);
export const RelatedAppsItemsPricingDataReceivedAction = 'RelatedAppsItemsPricingDataReceivedAction';
export const createRelatedAppsItemsPricingDataReceivedAction = actionCreator(RelatedAppsItemsPricingDataReceivedAction);
export const RecommendedAppsItemsPricingDataReceivedAction = 'RecommendedAppsItemsPricingDataReceivedAction';
export const createRecommendedAppsItemsPricingDataReceivedAction = actionCreator(RecommendedAppsItemsPricingDataReceivedAction);
export const RecommendedWhatsNewAppsReceivedAction = 'RecommendedWhatsNewAppsReceivedAction';
export const createRecommendedWhatsNewAppsReceivedAction = actionCreator(RecommendedWhatsNewAppsReceivedAction);
export const RecommendedTrendingAppsReceivedAction = 'RecommendedTrendingAppsReceivedAction';
export const createRecommendedTrendingAppsReceivedAction = actionCreator(RecommendedTrendingAppsReceivedAction);
export const RecommendedWhatsNewServiceReceivedAction = 'RecommendedWhatsNewServiceReceivedAction';
export const createRecommendedWhatsNewServiceReceivedAction = actionCreator(RecommendedWhatsNewServiceReceivedAction);
export const RecommendedTrendingServiceReceivedAction = 'RecommendedTrendingServiceReceivedAction';
export const createRecommendedTrendingServiceReceivedAction = actionCreator(RecommendedTrendingServiceReceivedAction);
export const RecommendedMicrosoft365WhatsNewAppsReceivedAction = 'RecommendedMicrosoft365WhatsNewAppsReceivedAction';
export const createRecommendedMicrosoft365WhatsNewAppsReceivedAction = actionCreator(RecommendedMicrosoft365WhatsNewAppsReceivedAction);
export const RecommendedMicrosoft365TrendingAppsReceivedAction = 'RecommendedMicrosoft365TrendingAppsReceivedAction';
export const createRecommendedMicrosoft365TrendingAppsReceivedAction = actionCreator(RecommendedMicrosoft365TrendingAppsReceivedAction);
export const BillingRegionReadFromCookieAction = 'BillingRegionReadFromCookieAction';
export const createBillingRegionReadFromCookieAction = actionCreator(BillingRegionReadFromCookieAction);
export const AppDetailPricingReceivedAction = 'AppDetailPricingReceivedAction';
export const createAppDetailPricingReceivedAction = actionCreator(AppDetailPricingReceivedAction);
export const SearchQueryChangedAction = 'SearchQueryChangedAction';
export const createSearchQueryChangedAction = actionCreator(SearchQueryChangedAction);
export const SearchDataReceivedAction = 'SearchDataReceivedAction';
export const createSearchDataReceivedAction = actionCreator(SearchDataReceivedAction);
export const SearchSuggestionsRequestId = 'SearchSuggestionsRequestId';
export const setSuggestionsRequestId = actionCreator(SearchSuggestionsRequestId);
export const CuratedDataReceivedAction = 'CuratedDataReceivedAction';
export const createCuratedDataReceivedAction = actionCreator(CuratedDataReceivedAction);
export const DataMapReceivedAction = 'DataMapReceivedAction';
export const createDataMapReceivedAction = actionCreator(DataMapReceivedAction);
export const UserSignInAction = 'UserSignInAction';
export const createUserSignInAction = actionCreator(UserSignInAction);
export const UserSignInStatusAction = 'UserSignInStatusAction';
export const UserSignInFetchStatusAction = 'UserSignInFetchStatusAction';
export const UserSignInStatusDataAction = 'UserSignInStatusDataAction';
export const UserAccesstokensAction = 'UserAccesstokensAction';
export const UserLoginDetailsAction = 'UserLoginDetailsAction';
export const createUserSignInStatusAction = actionCreator(UserSignInStatusAction);
export const createUserSignInStatusDataAction = actionCreator(UserSignInStatusDataAction);
export const createUserSignInFetchStatusAction = actionCreator(UserSignInFetchStatusAction);
export const createUserAccesstokensAction = actionCreator(UserAccesstokensAction);
export const createUserLoginDetailsAction = actionCreator(UserLoginDetailsAction);
export const ABTestingEnableAction = 'ABTestingEnableAction';
export const createABTestingAction = actionCreator(ABTestingEnableAction);
export const EmbedUserSignInAction = 'EmbedUserSignInAction';
export const createEmbedUserSignInAction = actionCreator(EmbedUserSignInAction);
export const NpsAction = 'NpsAction';
export const createNpsAction = actionCreator(NpsAction);
export const UserReviewUpdateAction = 'UserReviewUpdateAction';
export const createUserReviewUpdatedAction = actionCreator(UserReviewUpdateAction);
export const EmbeddedAppSettingAction = 'EmbeddedAppSettingAction';
export const createEmbeddedAppSettingAction = actionCreator(EmbeddedAppSettingAction);
export const SetInitLoadingAction = 'SetInitLoadingAction';
export const createSetInitLoadingAction = actionCreator(SetInitLoadingAction);
export const NationalCloudSettingAction = 'NationalCloudSettingAction';
export const createNationalCloudSettingAction = actionCreator(NationalCloudSettingAction);
export const EmbeddedHostAction = 'EmbeddedHostAction';
export const createEmbeddedHostAction = actionCreator(EmbeddedHostAction);
export const LocStringsReceivedAction = 'LocStringsReceivedAction';
export const createLocStringsReceivedAction = actionCreator(LocStringsReceivedAction);
export const I18nextReceivedAction = 'I18nextReceivedAction';
export const createI18nextReceivedAction = actionCreator(I18nextReceivedAction);
export const FlightCodesReceivedAction = 'FlightCodesReceivedAction';
export const createFlightCodesReceivedAction = actionCreator(FlightCodesReceivedAction);
export const IncludeTestProductsReceivedAction = 'IncludeTestProductsReceivedAction';
export const createIncludeTestProductsReceivedAction = actionCreator(IncludeTestProductsReceivedAction);
export const IsConverged = 'IsConverged';
export const createIsConverged = actionCreator(IsConverged);
export const CorrelationIdReceivedAction = 'CorrelationIdReceivedAction';
export const createCorrelationIdAction = actionCreator(CorrelationIdReceivedAction);
export const RequestIdReceivedAction = 'RequestIdReceivedAction';
export const createRequestIdAction = actionCreator(RequestIdReceivedAction);
export const TelemetryLoggedAction = 'TelemetryLoggedAction';
export const createAppViewTelemetryLoggedAction = actionCreator(TelemetryLoggedAction);
export const AppsPricingDataReceivedAction = 'AppsPricingAction';
export const createAppsPricingDataReceivedAction = actionCreator(AppsPricingDataReceivedAction);
export const AppPricingDataReceivedAction = 'AppPricingAction';
export const createAppPricingDataReceivedAction = actionCreator(AppPricingDataReceivedAction);
export const AppPricingDataRequestedAction = 'AppPricingRequestedAction';
export const createAppPricingDataRequestedAction = actionCreator(AppPricingDataRequestedAction);
export const FeatureFlagsReceivedAction = 'FeatureFlagsReceivedAction';
export const createFeatureFlagsReceivedAction = actionCreator(FeatureFlagsReceivedAction);
export const AddSubscriptionsInTenant = 'AddSubscriptionsInTenant';
export const createAddSubscriptionsInTenant = actionCreator(AddSubscriptionsInTenant);
export const UpdateUserRoleDefinitions = 'UpdateUserRoleDefinitions';
export const createUpdateUserRoleDefinitions = actionCreator(UpdateUserRoleDefinitions);
export const UserSegmentInitializeAction = 'UserSegmentInitializeAction';
export const createUserSegmentInitializeAction = actionCreator(UserSegmentInitializeAction);
export const UserSignOutAction = 'UserSignOutAction';
export const createUserSignOutAction = actionCreator(UserSignOutAction);
export const UserFieldHubTypeAction = 'UserFieldHubTypeAction';
export const createUserFieldHubTypeAction = actionCreator(UserFieldHubTypeAction);
export const CountriesDataReceivedAction = 'CountriesDataReceivedAction';
export const createServicesCountriesDataReceivedAction = actionCreator(CountriesDataReceivedAction);
export const SetEntityDataRegionFiltersAction = 'SetEntityDataRegionFiltersAction';
export const createSetEntityDataRegionFiltersAction = actionCreator(SetEntityDataRegionFiltersAction);
export const GlobalSettingsReceivedAction = 'GlobalSettingsReceivedAction';
export const createGlobalSettingsReceivedAction = actionCreator(GlobalSettingsReceivedAction);
export const IsMobileReceivedAction = 'IsMobileReceivedAction';
export const createIsMobileReceivedAction = actionCreator(IsMobileReceivedAction);
export const DynamicCampaignReceivedAction = 'CampaignReceivedAction';
export const createDynamicCampaignReceivedAction = actionCreator(DynamicCampaignReceivedAction);
export const CheckoutConfigAction = 'CheckoutConfigAction';
export const createCheckoutConfigAction = actionCreator(CheckoutConfigAction);
export const SetTenantTypeAction = 'SetTenantTypeAction';
export const createSetTenantTypeAction = actionCreator(SetTenantTypeAction);
export const UserOrdersAction = 'UserOrdersAction';
export const createUserOrdersAction = actionCreator(UserOrdersAction);
export const SetUserOrdersLoadingAction = 'SetUserOrdersLoadingAction';
export const createSetUserOrdersLoadingAction = actionCreator(SetUserOrdersLoadingAction);
export const IsManageModalOpenAction = 'IsManageModalOpenAction';
export const createIsManageModalOpenAction = actionCreator(IsManageModalOpenAction);
export const SetWCPConsentAction = 'SetWCPConsentAction';
export const createSetWCPConsentAction = actionCreator(SetWCPConsentAction);
export const SetIsConsentRequired = 'SetIsConsentRequired';
export const createSetIsConsentRequiredAction = actionCreator(SetIsConsentRequired);
export const LoadFavouriteDataStateAction = 'LoadFavouriteDataStateAction';
export const createLoadFavouriteDataStateAction = actionCreator(LoadFavouriteDataStateAction);
export const UserPrivateOffersAction = 'UserPrivateOffersAction';
export const createUserPrivateOffersAction = actionCreator(UserPrivateOffersAction);
export const ToggleShowContextPanel = 'ToggleShowContextPanel';
export const createToggleShowContextPanel = actionCreator(ToggleShowContextPanel);
export const SetUserPrivateOffersLoadingAction = 'SetPrivateOffersLoadingAction';
export const createSetUserPrivateOffersLoadingAction = actionCreator(SetUserPrivateOffersLoadingAction);
export const SetAccessTokenAction = 'SetAccessTokenAction';
export const createSetAccessTokenAction = actionCreator(SetAccessTokenAction);
export const ChangeLocaleLanguage = 'ChangeLocaleLanguage';
export const createChangeLocaleLanguage = actionCreator(ChangeLocaleLanguage);
export const SetIsDisabledBilling = 'createIsDisabledBilling';
export const createSetIsDisabledBilling = actionCreator(SetIsDisabledBilling);
export const LoadingRecommenededSizes = 'LoadingRecommenededSizes';
export const createLoadingRecommenededSizes = actionCreator(LoadingRecommenededSizes);
export const SetRecommenededSizes = 'SetRecommenededSizes';
export const createSetRecommenededSizes = actionCreator(SetRecommenededSizes);
